import { render } from "./AnonymousPage.vue?vue&type=template&id=3e5de88c&ts=true"
import script from "./AnonymousPage.vue?vue&type=script&lang=ts"
export * from "./AnonymousPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__